import React from 'react';
import { Card, Form, Tab, Tabs, ToggleButton, Button } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

interface PropsType {
  types: any;
  type: string;
  provider: string;
  onChangeType: any;
  onChangeAmount: any;
  onSubmit: any;
  onWithdraw: any;
  customer: any;
  selectedAccount: any;
  dbs: any;
  withdrawData: any;
  razorpay: any;
  isLoading: boolean;
}

const AddWithdrawMoney: React.FC<PropsType> = ({
  isLoading,
  types,
  type,
  provider,
  onChangeType,
  onChangeAmount,
  onSubmit,
  onWithdraw,
  customer,
  selectedAccount,
  dbs,
  withdrawData,
  razorpay,
}) => (
  <Card className=''>
    <Card.Body>
      <Tabs
        defaultActiveKey='withdraw'
        id='uncontrolled-tab-example'
        className='mb-3 justify-content-center'
      >
        {/* <Tab eventKey='add' title='Add'>
          <Form>
            <Form.Group className='mb-3' controlId='askPrice'>
              <div className='d-flex justify-content-between'>
                {types.map((radio, key) => (
                  <ToggleButton
                    // eslint-disable-next-line react/no-array-index-key
                    key={key}
                    id={`radio-${key}`}
                    type='radio'
                    name='radio'
                    variant='warning'
                    style={{
                      width: '48%',
                    }}
                    value={radio.value}
                    checked={type === radio.value}
                    onChange={(e) => onChangeType(e)}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </div>
              
            </Form.Group>

            <Form.Group className='mb-3' controlId='askPrice'>
              <Form.Label>Enter amount to be added</Form.Label>

              <CurrencyInput
                disabled={
                  customer.active === 'DISABLED' ||
                  Object.keys(selectedAccount).length === 0 ||
                  selectedAccount.active === 'DISABLED'
                }
                className='text-end form-control'
                name='amount'
                allowNegativeValue={false}
                value={razorpay.amount}
                onWheel={(e: any) => e.target.blur()}
                onValueChange={(value, name) =>
                  onChangeAmount(value, name, true)
                }
                prefix='₹ '
                decimalsLimit={2}
                placeholder='₹ 0.00'
              />
            
            </Form.Group>
            <div className='d-flex justify-content-around mb-3 mt-3 tg-btns'>
              {[100, 500, 1000, 10000].map((amount) => (
                <Button
                  variant='outline-warning'
                  size='sm'
                  onClick={(e) => {
                    onChangeAmount(
                      razorpay.amount
                        ? Number(razorpay.amount) + Number(amount)
                        : Number(amount),
                      'amount',
                      true
                    );
                  }}
                >
                  + ₹{amount}
                </Button>
              ))}
            </div>

            <div className='d-grid mb-3'>
              <Button
                variant='primary'
                onClick={onSubmit}
                size='lg'
                disabled={
                  customer.active === 'DISABLED' ||
                  Object.keys(selectedAccount).length === 0 ||
                  selectedAccount.active === 'DISABLED' ||
                  isLoading
                }
              >
                {!isLoading ? (
                  'Proceed'
                ) : (
                  <div className='spinner-border text-white' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                )}
              </Button>
            </div>
          </Form>
        </Tab> */}

        <Tab eventKey='withdraw' title='Withdraw'>
          <Form>
            <Form.Group className='mb-3' controlId='askPrice'>
              <Form.Label>Enter amount to be withdrawn</Form.Label>

              <CurrencyInput
                disabled={
                  customer.active === 'DISABLED' ||
                  Object.keys(selectedAccount).length === 0 ||
                  selectedAccount.active === 'DISABLED'
                }
                className='text-end form-control'
                name='amount'
                allowNegativeValue={false}
                value={withdrawData.amount}
                onWheel={(e: any) => e.target.blur()}
                onValueChange={(value, name) =>
                  onChangeAmount(value, name, false)
                }
                decimalsLimit={2}
                prefix='₹ '
                placeholder='₹ 0.00'
              />
              {/*<Form.Control
                type="number"
                name="amount"
                autoComplete="off"
                disabled={customer.active === "DISABLED" || Object.keys(selectedAccount).length === 0 || selectedAccount.active === "DISABLED"}
                onChange={(e) => onChangeAmount(e, false)}
                className="text-right"
                placeholder="0.00"
                onWheel={(e: any) => e.target.blur()}
              />*/}
            </Form.Group>

            <div className='d-grid mb-3'>
              <Button
                variant='primary'
                onClick={onWithdraw}
                size='lg'
                disabled={
                  customer.active === 'DISABLED' ||
                  Object.keys(selectedAccount).length === 0 ||
                  selectedAccount.active === 'DISABLED' ||
                  isLoading
                }
              >
                {!isLoading ? (
                  'Proceed'
                ) : (
                  <div className='spinner-border text-white' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                )}
              </Button>
            </div>
          </Form>
        </Tab>
      </Tabs>
    </Card.Body>
  </Card>
);

export default AddWithdrawMoney;
